import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {initElements} from '../define/shared'

gsap.registerPlugin(ScrollTrigger)


export function refreshScrollTrigger() {
    ScrollTrigger.refresh()
}

export default function initReveal() {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) {
            refreshScrollTrigger()
        }
    }))

    initElements('[data-reveal]', initElement, {
        observe: true,
        observerFilterFn(el) {
            return !!el.dataset.reveal
        }
    })

    refreshScrollTrigger()
    window.addEventListener('resize', refreshScrollTrigger)
    window.addEventListener('orientationchange', refreshScrollTrigger)
    window.addEventListener('load', refreshScrollTrigger)

    // Refresh ScrollTrigger every time image is loaded
    initElements('img[loading]', img => {
        img.addEventListener('load', event => {
            refreshScrollTrigger()
        }, { once: true })
    }, {
        observe: true,
        observerFilterFn(el) {
            return el.nodeName === 'IMG' && el.hasAttribute('loading') && !el.complete
        }
    })

    window.addEventListener('beforeunload', event => {
        [].slice.apply(document.querySelectorAll('.is--revealed')).forEach(el => {
            setTimeout(() => el.classList.remove('is--revealed'), 50)
        })
    })

    /**
     * @param {HTMLElement} el
     */
    function initElement(el) {
        el.classList.add('is--revealInit')
        if (el.dataset.revealDelay) {
            el.style.transitionDelay = el.dataset.revealDelay
        }
        observer.observe(el)
        return ScrollTrigger.create({
            trigger: el,
            start: `top ${el.dataset.revealTriggerOffset || '95%'}`,
            toggleClass: { targets: el, className: 'is--revealed' },
            toggleActions: 'play reverse none none',
            invalidateOnRefresh: true,
        })
    }
}
